export default "<adn-delete model=\"ctrl.model\" block-delete=\"ctrl.blockDelete\" model-comms=\"ctrl.modelComms\" is-new=\"ctrl.isNew\"></adn-delete>\n\n";